import { Link, Text } from 'braid-design-system';
import React from 'react';

import {
  createNavLinks,
  getLoginNavButtonProps,
  navLinkIds,
} from '../utils/generalUtils';

import * as styles from './NavTextLink.css';

interface NavTextLinkInstanceProps {
  baseUrl: string;
}

export const SignInTextLink = ({ baseUrl }: NavTextLinkInstanceProps) => (
  <NavTextLink id={navLinkIds.signIn} href={createNavLinks(baseUrl).signIn}>
    Sign in
  </NavTextLink>
);

export const RegisterTextLink = ({ baseUrl }: NavTextLinkInstanceProps) => (
  <NavTextLink id={navLinkIds.register} href={createNavLinks(baseUrl).register}>
    Register
  </NavTextLink>
);

// ============================================================================
// NavTextLink
// ============================================================================

interface NavTextLinkProps {
  id: string;
  href: string;
  children: string;
}

const NavTextLink = ({ id, href, children }: NavTextLinkProps) => (
  <Text size="small">
    <Link
      {...getLoginNavButtonProps(href)}
      id={id}
      className={styles.navTextLink}
      data={{
        text: children,
        htag: id,
      }}
    >
      {children}
    </Link>
  </Text>
);
